module.exports = __webpack_public_path__ + "static/media/art68.6ab2d4d7.jpg";